<template>
  <div :class="{ openMenu: dropdownMenu }">
    <!-- 메뉴 열림 시 배경 dim 처리 및 클릭 시 메뉴 닫기 -->
    <div class="dimm" @click.stop="dropdownMenu = false"></div>

    <div id="header" :class="{ reverse: !isScroll, isMobile: isMobile }">
      <div class="nav">
        <div class="container">
          <div class="menuBox">
            <div class="topBtns">
              <!-- 뒤로가기 버튼 -->
              <button class="goBack" @click="goBack"></button>

              <!-- 모바일 메뉴 토글 버튼 -->
              <button type="button" class="btnApp" @click="toggleMenu"></button>

              <!-- 로고 클릭 시 메인 페이지 이동 또는 스크롤 최상단 -->
              <a href="javascript:void(0)" class="logo" @click="mainAction"></a>

              <!-- 로그인 여부에 따라 마이페이지 또는 로그인 페이지 링크 -->
              <router-link :to="{ name: isLogin ? 'myPage' : 'login' }" type="button" class="btnUser"></router-link>
            </div>
          </div>
        </div>
      </div>

      <div id="overlay"></div>

      <!-- 사이드바 메뉴 -->
      <nav id="sideBar">
        <div ref="parentDiv" class="contents">
          <div class="topBtns">
            <!-- 사이드바 내 로고 클릭 시 메인 페이지로 이동 -->
            <router-link :to="{ name: 'main' }" class="logo"></router-link>
          </div>

          <!-- 검색 박스 (주석 처리됨) -->
          <!--
          <div class="search">
            <input type="text" class="input" placeholder="검색어를 입력하세요.">
            <button type="button" class="btnSearch"></button>
          </div>
          -->

          <!-- 하단 로그인/회원가입/마이페이지 링크 -->
          <div class="footer">
            <a href="javascript:void(0)" class="login" @click="loginAction">{{ isLogin ? '로그아웃' : '로그인' }}</a>
            <router-link v-if="!isLogin" :to="{ name: 'join' }" class="join">회원가입</router-link>
            <router-link v-if="isLogin" :to="{ name: 'myPage' }" class="myPage">마이페이지</router-link>
          </div>

          <!-- 메뉴 리스트 -->
          <div class="menu" @mouseenter="enableScroll" @mouseleave="disableScroll">
            <ul>
              <li v-for="(item, index) in menu" :key="index">
                <!-- feeds 메뉴 제외, children 유무에 따라 div 또는 router-link 컴포넌트 렌더링 -->
                <component
                  v-if="!item.name.includes('feeds')"
                  :is="item.children ? 'div' : 'router-link'"
                  :to="{ name: item.name }"
                  @click.stop="openMenuIsMobile(item)"
                  class="menuanchor mainMenu"
                  :class="{ open: item.isActive }"
                >
                  <span :class="{ pr: item.children }">{{ item.meta.title }}</span>
                </component>

                <!-- 하위 메뉴 있으면 하위 리스트 출력 -->
                <ul v-if="item.children" class="children">
                  <li v-for="(children, i) in item.children" :key="i">
                    <router-link
                      :to="{ name: children.name, ...(children.params && { params: children.params }) }"
                      class="menuanchor"
                    >
                      {{ children.meta.title }}
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- 고정 메뉴: 온라인 스토어 -->
              <li>
                <div class="menuanchor mainMenu none">
                  <a href="https://www.jdfcstore.com" target="_blank" class="pr">온라인 스토어</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 사이드바 닫기 버튼 -->
        <div class="close">
          <button type="button" class="btnClose" @click="toggleMenu"></button>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderView',

  // computed는 스토어에서 로그인 상태 가져옴
  computed: {
    isLogin() {
      return this.$store.getters['getLoginState'];
    },
  },

  created() {
    // 라우터 옵션에서 meta.title 있는 메뉴만 필터링 후 children 필터링 처리
    this.menu = this.$router.options.routes
      ? this.$router.options.routes
        .filter((x) => {
          x.isActive = false;
          return x.meta && x.meta.title;
        })
        .map((x) => ({
          ...x,
          ...(x.children && {
            children: x.children.filter((c) => c.meta && c.meta.title),
          }),
        }))
      : [];
  },

  mounted() {
    // 문서 스크롤, 윈도우 리사이즈 이벤트 등록
    document.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);

    this.$nextTick(() => {
      this.onScroll();
      this.onResize();
    });
  },

  watch: {
    // 라우트 변경 시 init 실행
    $route(to, from) {
      if (to.path !== from.path) {
        this.init();
      }
    },
  },

  data() {
    return {
      isScroll: true, // 스크롤 여부 플래그
      isMobile: true, // 모바일 환경 여부
      dropdownMenu: false, // 메뉴 열림 여부
      menu: [], // 메뉴 리스트
    };
  },

  methods: {
    // 메뉴 상태 초기화 및 메뉴 닫기
    init() {
      this.dropdownMenu = false;
      Object.entries(this.menu).forEach(([, val]) => {
        val.isActive = false;
      });
    },

    // 스크롤 높이에 따른 헤더 색상/배경 등 변경 플래그 관리
    onScroll() {
      const height = this.isMobile ? 80 : 130;
      // this.isScroll = window.scrollY >= height;
    },

    // 화면 크기 변경 시 isMobile 설정 및 onScroll 호출
    onResize() {
      this.onScroll();
      this.isMobile = window.innerWidth < 960;
    },

    // 메뉴 열림/닫힘 토글
    toggleMenu() {
      this.dropdownMenu = !this.dropdownMenu;
    },

    // 모바일 메뉴에서 현재 클릭한 메뉴만 열고 나머지 닫기
    openMenuIsMobile(item) {
      Object.entries(this.menu).forEach(([, val]) => {
        val.isActive = val.name === item.name ? !val.isActive : false;
      });
    },

    // 뒤로가기 동작, 특정 경로에서 커스텀 동작 구현
    goBack() {
      const currentRoute = this.$route.name;

      if (currentRoute === 'fansDetail' && this.$route.params.page) {
        this.$router.push({ name: this.$route.params.page });
      } else if (currentRoute === 'playerDetail') {
        this.$router.push({ name: 'playerTeam' });
      } else if (window.history.length > 1) {
        this.$router.go(-1);
      }
    },

    // 로그인/로그아웃 액션 분기 처리
    loginAction() {
      if (this.isLogin) {
        this.$store.dispatch('logout');
      } else {
        this.$router.push({ name: 'login' });
      }
    },

    // 로고 클릭 시 메인 페이지가 아니면 이동, 같으면 최상단 스크롤
    mainAction() {
      if (this.$route.name === 'main') {
        window.scrollTo(0, 0);
      } else {
        this.$router.push({ name: 'main' });
      }
    },

    // 메뉴 영역 마우스 엔터 시 스크롤 가능하게 설정
    enableScroll() {
      this.$refs.parentDiv.style.overflowY = 'scroll';
    },

    // 마우스 리브 시 스크롤 숨김
    disableScroll() {
      this.$refs.parentDiv.style.overflowY = 'hidden';
    },
  },
};
</script>
